(() => {
  if (window.NoonriseBikiniSetCartIntegrityLoaded) return;

  window.NoonriseBikiniSetCartIntegrityLoaded = true;

  let repairInProgress = false;

  function getSetUpdates(cart) {
    const groups = new Map();
    const updates = {};

    for (const item of cart?.items || []) {
      const setId = item.properties?._noonrise_set_id;

      if (!setId) continue;

      if (!groups.has(setId)) {
        groups.set(setId, []);
      }

      groups.get(setId).push(item);
    }

    for (const items of groups.values()) {
      const top = items.find(
        (item) =>
          item.properties?._noonrise_set_piece === 'Top'
      );

      const bottom = items.find(
        (item) =>
          item.properties?._noonrise_set_piece === 'Bottom'
      );

      /*
       * Incomplete or malformed set:
       * remove every remaining component.
       */
      if (!top || !bottom || items.length !== 2) {
        items.forEach((item) => {
          updates[item.key] = 0;
        });

        continue;
      }

      /*
       * Keep quantities synchronized.
       * Uses the lower quantity to avoid adding an
       * extra component or increasing the cart total.
       */
      const setQuantity = Math.min(
        Number(top.quantity) || 0,
        Number(bottom.quantity) || 0
      );

      if (top.quantity !== setQuantity) {
        updates[top.key] = setQuantity;
      }

      if (bottom.quantity !== setQuantity) {
        updates[bottom.key] = setQuantity;
      }
    }

    return updates;
  }

  function repairBikiniSets(cart) {
    if (
      repairInProgress ||
      typeof window.liquidAjaxCart?.update !== 'function'
    ) {
      return;
    }

    const updates = getSetUpdates(cart);

    if (!Object.keys(updates).length) {
      return;
    }

    repairInProgress = true;

    window.liquidAjaxCart.update(
      { updates },
      {
        important: true,

        info: {
          noonriseBikiniSetRepair: true,
        },

        lastCallback() {
          repairInProgress = false;
        },
      }
    );
  }

  function initializeIntegrityCheck() {
    repairBikiniSets(window.liquidAjaxCart?.cart);
  }

  if (window.liquidAjaxCart?.init) {
    initializeIntegrityCheck();
  } else {
    document.addEventListener(
      'liquid-ajax-cart:init',
      initializeIntegrityCheck,
      { once: true }
    );
  }

  document.addEventListener(
    'liquid-ajax-cart:request-end',
    (event) => {
      const requestState = event.detail?.requestState;

      /*
       * Avoid reacting recursively to our own repair request.
       */
      if (
        requestState?.info?.noonriseBikiniSetRepair
      ) {
        return;
      }

      if (event.detail?.cart) {
        repairBikiniSets(event.detail.cart);
      }
    }
  );

    function getNoonriseVisualCartCount(cart) {
    let regularItemCount = 0;
    const bikiniSets = new Map();

    for (const item of cart?.items || []) {
      const quantity = Number(item.quantity) || 0;
      const setId = item.properties?._noonrise_set_id;

      /*
       * Normal products continue counting normally.
       */
      if (!setId) {
        regularItemCount += quantity;
        continue;
      }

      /*
       * Top and Bottom share the same set ID.
       * Count that pair only once.
       */
      const currentQuantity = bikiniSets.get(setId) || 0;

      bikiniSets.set(
        setId,
        Math.max(currentQuantity, quantity)
      );
    }

    let setCount = 0;

    for (const quantity of bikiniSets.values()) {
      setCount += quantity;
    }

    return regularItemCount + setCount;
  }

  function updateNoonriseVisualCartCount(cart) {
    const visualCount =
      getNoonriseVisualCartCount(
        cart || window.liquidAjaxCart?.cart
      );

    document
      .querySelectorAll(
        '[data-ajax-cart-bind="item_count"]'
      )
      .forEach((counter) => {
        counter.textContent = String(visualCount);
        counter.dataset.noonriseVisualCount =
          String(visualCount);
      });
  }

  function scheduleNoonriseCartCountUpdate(cart) {
    /*
     * Wait until Liquid Ajax Cart finishes replacing
     * the relevant HTML sections.
     */
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        updateNoonriseVisualCartCount(cart);
      });
    });
  }

  if (window.liquidAjaxCart?.init) {
    scheduleNoonriseCartCountUpdate(
      window.liquidAjaxCart.cart
    );
  } else {
    document.addEventListener(
      'liquid-ajax-cart:init',
      (event) => {
        scheduleNoonriseCartCountUpdate(
          event.detail?.cart ||
          window.liquidAjaxCart?.cart
        );
      },
      { once: true }
    );
  }

  document.addEventListener(
    'liquid-ajax-cart:request-end',
    (event) => {
      scheduleNoonriseCartCountUpdate(
        event.detail?.cart ||
        window.liquidAjaxCart?.cart
      );
    }
  );

    function setNoonriseSetQuantityLoading(card, loading) {
    const currentQuantity =
      Number(card.dataset.noonriseSetQuantity) || 1;

    card.toggleAttribute('processing', loading);

    card
      .querySelectorAll(
        '[data-noonrise-set-quantity-action]'
      )
      .forEach((button) => {
        const action =
          button.dataset.noonriseSetQuantityAction;

        button.disabled =
          loading ||
          (
            action === 'decrease' &&
            currentQuantity <= 1
          );
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-noonrise-set-quantity-action]'
      );

      if (!button) return;

      const card = button.closest(
        '[data-noonrise-set-card]'
      );

      if (!card) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const action =
        button.dataset.noonriseSetQuantityAction;

      const currentQuantity =
        Number(card.dataset.noonriseSetQuantity) || 1;

      const nextQuantity =
        action === 'increase'
          ? currentQuantity + 1
          : Math.max(1, currentQuantity - 1);

      if (nextQuantity === currentQuantity) return;

      const topKey = card.dataset.noonriseTopKey;
      const bottomKey = card.dataset.noonriseBottomKey;

      const message = card.querySelector(
        '[data-noonrise-set-quantity-message]'
      );

      if (
        !topKey ||
        !bottomKey ||
        typeof window.liquidAjaxCart?.update !== 'function'
      ) {
        if (message) {
          message.textContent =
            'The cart could not be updated.';
        }

        return;
      }

      if (message) {
        message.textContent = '';
      }

      setNoonriseSetQuantityLoading(card, true);

      window.liquidAjaxCart.update(
        {
          updates: {
            [topKey]: nextQuantity,
            [bottomKey]: nextQuantity,
          },
        },
        {
          important: true,

          info: {
            noonriseBikiniSetQuantity: true,
            setId: card.dataset.noonriseSetId,
          },

          lastCallback(requestState) {
            const successful = Boolean(
              requestState.responseData?.ok
            );

            if (successful) return;

            const responseBody =
              requestState.responseData?.body || {};

            const errorMessage =
              responseBody.description ||
              responseBody.message ||
              requestState.fetchError?.message ||
              'The set quantity could not be updated.';

            if (message) {
              message.textContent = errorMessage;
            }

            setNoonriseSetQuantityLoading(
              card,
              false
            );
          },
        }
      );
    },
    true
  );

})();